import { FC, ReactNode, useEffect } from 'react';
import tw, { styled } from 'twin.macro';

import CloseIcon from '~/shared/assets/icons/close.svg';

// import Button from '~/shared/components/ds/buttons/Button';

type ModalProps = {
  showModal: boolean;
  onClose: VoidFunction;
  showHeader?: boolean;
  title?: string | ReactNode;
  size?: 'large' | 'medium';
  className?: string;
};

const Modal: FC<ModalProps & { children: ReactNode }> = ({
  showModal,
  onClose,
  children,
  showHeader = true,
  title,
  size,
  className,
}) => {
  useEffect(() => {
    showModal ? (document.body.style.overflow = 'hidden') : (document.body.style.overflow = '');
  }, [showModal]);

  return (
    <>
      {showModal ? (
        <>
          <Wrapper>
            <div className="relative w-full my-auto mx-auto ">
              <ModalRoot $size={size} className={className}>
                <button className="absolute right-[15px] top-[17px] z-10" onClick={onClose}>
                  <CloseIcon className="w-[18px] h-[18px] fill-[#949EAC]" />
                </button>

                <Header className={`${showHeader ? 'flex px-[20px] py-[16px] ' : 'hidden'} `}>
                  {typeof title === 'string' ? (
                    <div
                      // variant="H4"
                      // color="text-gray-600"
                      className="whitespace-nowrap w-[94%]"
                      // ellipsis
                    >
                      {title}
                    </div>
                  ) : title ? (
                    title
                  ) : null}
                </Header>

                <Body>{children}</Body>
              </ModalRoot>
            </div>
          </Wrapper>
          <OpaqueBackground></OpaqueBackground>
        </>
      ) : null}
    </>
  );
};

export default Modal;

const Wrapper = tw.div`
justify-center flex overflow-x-auto px-[24px] overflow-y-auto fixed inset-0 z-[100] outline-none focus:outline-none 
`;

const ModalRoot = styled.div<{ $size?: ModalProps['size'] }>(({ $size }) => [
  tw`border-0 rounded-[16px] shadow-modal relative 
    flex flex-col bg-white outline-none h-fit
    focus:outline-none mx-auto min-h-[120px]`,
  $size === 'large' ? tw`w-[1616px] min-w-[1240px] max-w-[86.25%]` : tw`w-[745px]`,
]);

const Header = tw.div`
items-start justify-between`;

const Body = tw.div`
relative flex-auto p-[20px]`;

const OpaqueBackground = tw.div`
 fixed inset-0 z-[99] bg-[##07103166] backdrop-blur-[5px] `;
